import { render, staticRenderFns } from "./ExternalEssay.vue?vue&type=template&id=1fb7c9bc&scoped=true"
import script from "./ExternalEssay.vue?vue&type=script&lang=js"
export * from "./ExternalEssay.vue?vue&type=script&lang=js"
import style0 from "./ExternalEssay.vue?vue&type=style&index=0&id=1fb7c9bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb7c9bc",
  null
  
)

export default component.exports